import React from 'react';
import { useTranslation } from 'react-i18next';

import { useProfile } from '@/entities/profile';
import { Box, Stack, Tooltip } from '@/shared/ui';
import { IconButton } from '@/shared/ui/lib/IconButton';
import { Loader } from '@/shared/ui/Loader';
import { Menu } from '@/shared/ui/Menu';
import { SvgIcon } from '@/shared/ui/SvgIcon';
import { CustomTypography } from '@/shared/ui/Typography';

import { LanguageSwitcher } from '../LanguageSwitcher';

import { UserMenuTypography } from './styles';

type TProfileMenu = {
  actionsSlot?: React.ReactNode;
};

// TODO перенести в фичу profile
export const ProfileMenu = ({ actionsSlot }: TProfileMenu) => {
  const { t } = useTranslation();

  const { profile, isPending } = useProfile();

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <Box sx={{ flexGrow: 0 }}>
      <Tooltip title={t('common:header.userMenu.tooltip')}>
        <IconButton
          size="large"
          onClick={handleOpenUserMenu}
          variant="outlined"
        >
          <SvgIcon name="user" fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        id="userSettings"
        anchorEl={anchorElUser}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        keepMounted
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {isPending ? (
          <Box px={2}>
            <Loader containerSize="extraSmall" />
          </Box>
        ) : (
          <Stack direction="column" spacing={2}>
            <CustomTypography variant="subtitle2" color="text.primary">
              {profile?.email}
            </CustomTypography>

            {/* <Stack */}
            {/*  direction="row" */}
            {/*  spacing={2} */}
            {/*  alignItems="center" */}
            {/*  justifyContent="space-between" */}
            {/* > */}
            {/*  <UserMenuTypography> */}
            {/*    {t('common:header.userMenu.theme')} */}
            {/*  </UserMenuTypography> */}
            {/*  <Select value="system" size="small"> */}
            {/*    <MenuItem value="system">system</MenuItem> */}
            {/*  </Select> */}
            {/* </Stack> */}

            <Stack direction="row" spacing={2} alignItems="center">
              <UserMenuTypography>
                {t('common:header.userMenu.language')}
              </UserMenuTypography>
              <LanguageSwitcher />
            </Stack>

            {actionsSlot}
          </Stack>
        )}
      </Menu>
    </Box>
  );
};
